var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_615)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#9B5AF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2258 7.16129C8.98104 7.16129 7.16129 8.98104 7.16129 11.2258C7.16129 13.4706 8.98104 15.2903 11.2258 15.2903C13.4706 15.2903 15.2903 13.4706 15.2903 11.2258C15.2903 8.98104 13.4706 7.16129 11.2258 7.16129ZM6 11.2258C6 8.33967 8.33967 6 11.2258 6C14.1119 6 16.4516 8.33967 16.4516 11.2258C16.4516 14.1119 14.1119 16.4516 11.2258 16.4516C8.33967 16.4516 6 14.1119 6 11.2258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2991 14.2991C14.5259 14.0723 14.8935 14.0723 15.1203 14.2991L17.8299 17.0088C18.0567 17.2355 18.0567 17.6032 17.8299 17.8299C17.6032 18.0567 17.2355 18.0567 17.0088 17.8299L14.2991 15.1203C14.0723 14.8935 14.0723 14.5259 14.2991 14.2991Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconActive);
export default __webpack_public_path__ + "static/media/SearchIconActive.bfd03f1bf0a8e9ffa7723a3c065a5766.svg";
export { ForwardRef as ReactComponent };